// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Curaçao */
const CW = /^(?:953[01]\d{4}|9(?:5[12467]|6[5-9])\d{5})$/;

export default CW;
